var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_585_8584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.68 18.1199L4.95996 6.66993C8.11996 3.42993 12.53 1.42993 17.4 1.42993C22.27 1.42993 26.55 3.37993 29.7 6.52993L18.11 18.1199C17.71 18.5099 17.08 18.5199 16.67 18.1199H16.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8 18.83C34.8 28.44 27.01 36.23 17.4 36.23C7.79 36.23 0 28.44 0 18.83C0 16.68 0.39 14.62 1.1 12.73L16.56 28.45C17 28.9 17.74 28.84 18.11 28.33L31.93 9.26001C33.74 12 34.8 15.29 34.8 18.83Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4602 1.63001L31.9302 9.26001C31.2802 8.27001 30.5302 7.36001 29.7002 6.53001L35.9202 0.310014C36.8102 -0.579986 38.2002 0.610014 37.4602 1.63001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_585_8584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.67,
    height: 36.22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.0283fbda84766978acbd617f46f04e8f.svg";
export { ForwardRef as ReactComponent };